var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3AllDevicesCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0v36h36V0zM17.86 32.41A14.52 14.52 0 1132.38 17.9a14.53 14.53 0 01-14.52 14.51zM13.07 17.9a2.32 2.32 0 11-4.64 0 2.32 2.32 0 014.64 0zm14.23 0a2.32 2.32 0 11-4.64-.02 2.32 2.32 0 014.64.02zM57 38.75v-5.73a6.82 6.82 0 00-7-6.78A6.92 6.92 0 0043 33v5.75a13.43 13.43 0 1014 0zM50 60a9.4 9.4 0 01-4.11-17.85l1.11-.59V36h6v5.56l1.11.55A9.4 9.4 0 0150 60zm-2 7h4v9h-4v-9zm15.68-6.34L70 67l-2.83 2.83-6.36-6.36 2.87-2.81zm-27.16-.23l2.83 2.83L33 69.62l-2.85-2.82 6.37-6.37zM76 48v4h-9v-4h9zm-43 4h-9v-4h9v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_All_devices_categories.8ee85b09.svg";
export { SvgA3AllDevicesCategories as ReactComponent };